module.exports = __webpack_public_path__ + "static/media/info-icon.3d86d7f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/promocode/info-icon.svg
// module id = 1630
// module chunks = 103